export const mapSearchText = (searchText: string | null): string => {
  if (searchText && searchText.trim().length > 0) {
    return searchText;
  }
  return '';
};
